import {
  BarChart3, Laptop, Lightbulb, HeartHandshake, GraduationCap, Dumbbell,
  Wrench, TrendingUp, Puzzle, CalendarCheck, PenTool, Users, FileText, Flag,
  Search, ChefHat, Handshake, Trees, Palette, MessageCircleHeart, Ruler, Package,
  Briefcase, Hammer, FlaskConical, ClipboardList,
} from "lucide-react";

const MAP = {
  BarChart3, Laptop, Lightbulb, HeartHandshake, GraduationCap, Dumbbell,
  Wrench, TrendingUp, Puzzle, CalendarCheck, PenTool, Users, FileText, Flag,
  Search, ChefHat, Handshake, Trees, Palette, MessageCircleHeart, Ruler, Package,
  Briefcase, Hammer, FlaskConical, ClipboardList,
};

export default function ActivityIcon({ name, ...props }) {
  const Cmp = MAP[name] || Briefcase;
  return <Cmp {...props} />;
}
